import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FiHome, FiHeart, FiMenu, FiX, FiLogOut, FiGrid } from "react-icons/fi";
import { useApp } from "../context/AppContext";

export default function Navbar() {
  const { user, logout, favorites } = useApp();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/");
    setMobileOpen(false);
  };

  return (
    <nav className={`navbar navbar-expand-lg fixed-top navbar-custom ${scrolled ? "scrolled" : ""}`}>
      <div className="container">
        <Link className="navbar-brand-custom" to="/">
          <span className="brand-icon">
            <FiHome />
          </span>
          Home Discovery
        </Link>

        <button
          className="btn d-lg-none border-0"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>

        <div className={`collapse navbar-collapse ${mobileOpen ? "show" : ""}`}>
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => `nav-link nav-link-custom ${isActive ? "active" : ""}`}
                to="/"
                end
                onClick={() => setMobileOpen(false)}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => `nav-link nav-link-custom ${isActive ? "active" : ""}`}
                to="/properties"
                onClick={() => setMobileOpen(false)}
              >
                Properties
              </NavLink>
            </li>
            {user && (
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) => `nav-link nav-link-custom ${isActive ? "active" : ""}`}
                  to="/dashboard"
                  onClick={() => setMobileOpen(false)}
                >
                  <FiGrid className="me-1" />
                  Dashboard
                </NavLink>
              </li>
            )}
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => `nav-link nav-link-custom ${isActive ? "active" : ""}`}
                to="/about"
                onClick={() => setMobileOpen(false)}
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => `nav-link nav-link-custom ${isActive ? "active" : ""}`}
                to="/contact"
                onClick={() => setMobileOpen(false)}
              >
                Contact
              </NavLink>
            </li>
          </ul>

          <div className="d-flex align-items-center gap-2">
            {user && (
              <Link
                className="nav-link nav-link-custom position-relative"
                to="/favorites"
                onClick={() => setMobileOpen(false)}
              >
                <FiHeart />
                {favorites.length > 0 && (
                  <span className="badge bg-danger rounded-pill">{favorites.length}</span>
                )}
              </Link>
            )}

            {user ? (
              <div className="dropdown">
                <button
                  className="btn d-flex align-items-center gap-2 p-0 border-0"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="user-avatar">{user.avatar}</span>
                  <span className="fw-semibold d-none d-lg-inline" style={{ color: "var(--gray-700)", fontSize: "0.9rem" }}>
                    {user.name}
                  </span>
                </button>
                <ul className="dropdown-menu dropdown-menu-end shadow border-0 rounded-3 p-2">
                  <li>
                    <Link className="dropdown-item rounded-2 py-2" to="/dashboard" onClick={() => setMobileOpen(false)}>
                      <FiGrid className="me-2" /> Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item rounded-2 py-2" to="/favorites" onClick={() => setMobileOpen(false)}>
                      <FiHeart className="me-2" /> Favorites
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <button className="dropdown-item rounded-2 py-2 text-danger" onClick={handleLogout}>
                      <FiLogOut className="me-2" /> Logout
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <>
                <Link className="btn btn-nav btn-nav-outline" to="/login" onClick={() => setMobileOpen(false)}>
                  Login
                </Link>
                <Link className="btn btn-nav btn-nav-primary" to="/sign-up" onClick={() => setMobileOpen(false)}>
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
